import React from "react"
import { motion } from "framer-motion"
import data from "../../data.json"
import { Link } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCopyright } from "@fortawesome/free-regular-svg-icons"


export default function Footer(){
    const footerData = data.landing.footer
    const motionVariants = {
        hidden: { opacity: 0, x: 30 },
        visible: { opacity: 1, x: 0 }
    }
    
    return (
        <motion.div 
            className="flex flex-col justify-center items-center px-6 mt-6 mb-16"
            initial="hidden"
            whileInView="visible"
            variants={motionVariants}
            transition={{ duration: 0.9 }}
        >
            <div className="flex flex-wrap text-center text-main-green-900 justify-center items-center w-fit">
                <Link to="/" className="mx-0 my-auto lg:mr-6 font-source font-medium text-2xl pr-1 pb-3.5 lg:pb-1">
                    <img
                        src={require("../../assets/new-skillja-logo.png")}
                        className="w-14 lg:w-16"
                        alt="SkillJa logo"
                    />
                </Link>
                {footerData.subSections.map((section,index)=>(
                    <Link 
                        to={footerData.links[index]} 
                        key={index}
                        className="my-auto ml-auto mr-0 md:mx-6 font-semibold font-kulim pl-3 lg:px-0 pb-3 lg:pb-0 hover:text-main-green-500 cursor-pointer"
                    >
                        <p>{section}</p>
                    </Link>
                ))}
                <div className="flex mx-auto lg:ml-1 mb-auto pb-2 px-2 lg:pb-0">
                    <a href={'https://www.instagram.com/skillja.app/'} className="mx-3 cursor-pointer hover:opacity-80" target="_blank" rel="noopener noreferrer">
                        <img 
                            src={require('../../assets/icons/instagram-icon.png')}
                            className="w-6 h-6 lg:w-7 lg:h-7 text-main-green-900"
                            alt="social media icon for instagram"
                        />
                    </a>
                    {/* <img 
                        src={require('../../assets/icons/facebook-icon.png')}
                        className="w-6 h-6 lg:w-7 lg:h-7 text-main-green-900 mx-1 cursor-pointer" 
                        alt="social media icon for facebook"
                    />
                    <img 
                        src={require('../../assets/icons/twitter-icon.png')}
                        className="w-6 h-6 lg:w-7 lg:h-7 text-main-green-900 mx-1 cursor-pointer" 
                        alt="social media icon for twitter/X"
                    /> */}
                    <a href={'https://www.tiktok.com/@skillja.app'} className="mx-4 cursor-pointer hover:opacity-80" target="_blank" rel="noopener noreferrer">
                        <img 
                            src={require('../../assets/icons/tiktok-icon.png')}
                            className="w-6 h-6 lg:w-7 lg:h-7 text-main-green-900"
                            alt="social media icon for TikTok"
                        />
                    </a>
                </div> 
            </div>
            <div className="mx-auto flex flex-wrap justify-center mt-6 md:mt-4 text-main-green-900 font-kulim">
                <p className="mx-3 my-1 text-sm">
                    <FontAwesomeIcon icon={faCopyright} className="mr-1" />
                    SkillJa 2026
                </p>
                <Link to={'/terms-conditions'}>
                    <p className="mx-3 my-1 text-sm hover:text-main-green-500 cursor-pointer">
                        Terms
                    </p>
                </Link>
                <Link to={'/privacy-policy'}>
                    <p className="mx-3 my-1 text-sm hover:text-main-green-500 cursor-pointer">
                        Privacy
                    </p>
                </Link>
                <Link to={'/contact-us'}>
                    <p className="mx-3 my-1 text-sm hover:text-main-green-500 cursor-pointer">
                        Contact Us
                    </p>
                </Link>
                <Link to={'/merchandise'}>
                    <p className="mx-3 my-2 md:my-1 text-sm hover:text-main-green-500 cursor-pointer">
                        Merchandise
                    </p>
                </Link>
                <img 
                    src={require('../../assets/icons/stripe-logo.jpg')}  
                    className="w-12 rounded-lg my-1.5 md:my-auto border mx-2"
                />
            </div>
        </motion.div>
    )
}